import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/marketing/Reveal";

export default function SectorNewswires({ wires = [], browseLink = "/services/newswire-distribution", tag, title, subtitle }) {
  return (
    <section className="py-12 lg:py-16 bg-canvas">
      <Container>
        <Reveal>
        <SectionHeading tag={tag} title={title} subtitle={subtitle} />
        </Reveal>
        <div className="grid md:grid-cols-2 gap-5 lg:gap-6">
          {wires.map((w, i) => (
            <Reveal key={w.name} variant="card" delay={i * 0.08}>
            <div
              className="group bg-white border border-border rounded-xl p-7 lg:p-8 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 shrink-0">
                  <w.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-bold text-bone">{w.name}</h3>
                  <span className="text-xs font-mono uppercase tracking-wider text-cobalt mt-1 inline-block">{w.reach}</span>
                </div>
              </div>
              <p className="text-sm text-steel leading-relaxed mb-5">{w.desc}</p>
            </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
        <div className="mt-10 text-center">
          <Link
            to={browseLink}
            className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors"
          >
            Browse all newswires <ArrowRight className="ml-1.5 w-4 h-4" />
          </Link>
        </div>
        </Reveal>
      </Container>
    </section>
  );
}